import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'

const SubscriptionConflictDialog = ({ open, onCancel, onConfirm, protocol }) => (
  <Dialog open={open} onClose={onCancel} disableRestoreFocus>
    <DialogTitle>Foi identificada uma solicitação de pré-matrícula para este CPF.</DialogTitle>
    <DialogContent>
      {protocol && (
        <DialogContentText>
          Pré-matrícula que será cancelada: protocolo <strong>{protocol}</strong>.
        </DialogContentText>
      )}
      <DialogContentText>
        Declaro que estou ciente que, caso prossiga com a rematrícula, a pré-matrícula será cancelada.
      </DialogContentText>
      <DialogContentText>
        O cancelamento é irreversível: a rematrícula prevalece sobre a pré-matrícula, sem possibilidade de alteração.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>
        Desistir
      </Button>
      <Button onClick={onConfirm} color="primary">
        Prosseguir
      </Button>
    </DialogActions>
  </Dialog>
)

export default SubscriptionConflictDialog
